import { Button } from "antd-mobile";
const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-[var(--app-bg-06)] w-full h-100dvh fixed top-50% left-50% translate-[-50%] center flex-col gap-y-20 z-999">
      <h1 className="text-80 m-0 font-bolder lh-1em">404</h1>
      <div className='text-16 flex items-center font-lighter gap-6 before:content-["-"] after:content-["-"]'>
        PAGE NOT FOUND
      </div>
      <Button color="primary" fill="solid" size="small" onClick={() => navigate("/home", { replace: false })}>
        Back to Home
      </Button>
    </div>
  );
};
export default NotFound;
